export default function accountNoFilter(input) {
	if (input && input.replace)
		input = input.replace(/(.{4})/g, "$1 ");
	return input;
}


// WEBPACK FOOTER //
// ./src/modules/filter/accountNoFilter.js